import { Luck3dImg, Speed3dImg, Stamina3dImg } from "@/assets"
import { IUserUpgradeType, USER_UPGRADE_TYPE } from "@/store/apis/userAPI"

export const upgradeIconMap: Record<IUserUpgradeType, string> = {
  [USER_UPGRADE_TYPE.SPEED]: Speed3dImg,
  [USER_UPGRADE_TYPE.LUCK]: Luck3dImg,
  [USER_UPGRADE_TYPE.STAMINA]: Stamina3dImg
}
